import { getEnvironments } from '@gonfalon/openapi/operations/getEnvironments';

import { createQueryOptions } from '../internal/createQueryOptions';

export const internalEnvironmentList = createQueryOptions(getEnvironments);
